exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.event-name[data-v-3bf24e66] {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n.pointer[data-v-3bf24e66] {\n  cursor: pointer;\n}\n.w100[data-v-3bf24e66] {\n  width: 100%;\n}\n.pointer[data-v-3bf24e66] {\n  cursor: pointer;\n}\n", ""]);

// exports
